/**
 * 代码选区引用标签
 *
 * 显示在输入框顶部，展示当前选中的代码行范围。
 * 点击 × 可清除选区。
 */

import React from 'react';
import type { CodeSelection } from '../../types';

// ============================================
// Props
// ============================================

export interface CodeSelectionTagProps {
  /** 当前选区信息 */
  readonly selection: CodeSelection;
  /** 清除选区回调 */
  readonly onClear: () => void;
}

// ============================================
// 组件
// ============================================

export const CodeSelectionTag: React.FC<CodeSelectionTagProps> = ({
  selection,
  onClear
}) => {
  const lineLabel = selection.isFullSelection
    ? '全部代码'
    : `行 ${selection.startLine}-${selection.endLine}`;

  const lineCount = selection.isFullSelection
    ? selection.endLine
    : selection.endLine - selection.startLine + 1;

  return (
    <div className="plc-selection-tag">
      <i className="fa fa-code plc-selection-tag-icon" />
      <span className="plc-selection-tag-label">
        {lineLabel}
      </span>
      <span className="plc-selection-tag-meta">
        ({lineCount} 行 · {selection.language.toUpperCase()})
      </span>
      <button
        type="button"
        className="plc-selection-tag-close"
        onClick={onClear}
        aria-label="清除代码引用"
      >
        <i className="fa fa-times" />
      </button>
    </div>
  );
};

CodeSelectionTag.displayName = 'CodeSelectionTag';

export default CodeSelectionTag;